import { DatePicker, Form, Tabs, message } from 'antd';
import CustomBar from 'base/ui/components/CustomChart/BarChart';
import ChartSalesCampaign from 'base/ui/components/CustomChart/BarChart/ChartSalesCampaign';
import CustomSelect from 'base/ui/components/CustomSelect';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignModel } from 'services/Main/campaign_services';
import { campaignPresenter, campaignStore } from 'stores/root_store';
import { debounce } from 'utils/debounce';

type DataChart = {
  label: string[];
  data: number[];
};

function ChartTab() {
  const { t } = useTranslation();
  const [formRevenue] = Form.useForm();
  const [formAppointment] = Form.useForm();

  const [dataChartRevenue, setDataChartRevenue] = useState<DataChart>({
    label: [],
    data: [],
  });
  // Chart số lượng kh ghé thăm
  const [dataChartAppointment, setDataChartAppointment] = useState<DataChart>({
    label: [],
    data: [],
  });

  // Lấy data form Doanh số
  const yearChartRevenue = Form.useWatch('Year', formRevenue);
  const campaignChartRevenue = Form.useWatch('CampaignCode', formRevenue);

  // Lấy data form số lượng kh ghé thăm
  const yearChartAppointment = Form.useWatch('Year', formAppointment);
  const campaignChartAppointment = Form.useWatch('CampaignCode', formAppointment);

  // data table báo cáo
  const [listCampaign, setListCampaign] = useState<CampaignModel[]>([]);

  // Lấy data chart doanh số chiến dịch
  const getDataChartRevenue = async (year: number, campaignCode?: string) => {
    await campaignPresenter.getRevenueCampaign(campaignStore, year, campaignCode);
    if (campaignStore.listRevenueCampaign.isSuccess) {
      const dataAPI = cloneDeep(campaignStore.listRevenueCampaign.data);
      const dataLable = dataAPI.map((d) => d.monthCreate);
      const dataChart = dataAPI.map((d) => d.revenue || 0);
      setDataChartRevenue({
        data: dataChart,
        label: dataLable,
      });
    }
  };
  // Lấy data số lượng khách hàng ghé thăm
  const getDataChartAppointment = async (year: number, campaignCode?: string) => {
    await campaignPresenter.getAppointmentCampaign(campaignStore, year, campaignCode);
    if (campaignStore.listAppointmentCampaign.isSuccess) {
      const dataAPI = cloneDeep(campaignStore.listAppointmentCampaign.data);
      const dataLable = dataAPI.map((d) => d.monthCreate);
      const dataChart = dataAPI.map((d) => d.revenue || 0);
      setDataChartAppointment({
        data: dataChart,
        label: dataLable,
      });
    }
  };

  const getDataCampaign = async (key?: string) => {
    await campaignPresenter.getListCampaign(campaignStore, {
      paging: {
        pageSize: 20,
        pageIndex: 1,
      },
      name: key,
      // code: key,
    });
    if (campaignStore.listCampaign.isSuccess) {
      const dataTemp = cloneDeep(campaignStore.listCampaign.data);
      setListCampaign(dataTemp);
    } else {
      message.error(campaignStore.listCampaign.message);
    }
  };

  const debounceCampaign = useCallback(debounce(getDataCampaign, 300), []);

  useEffect(() => {
    getDataCampaign();
  }, []);

  useEffect(() => {
    if (yearChartRevenue) {
      getDataChartRevenue(yearChartRevenue.format('YYYY'), campaignChartRevenue);
    }
  }, [yearChartRevenue, campaignChartRevenue]);

  useEffect(() => {
    if (yearChartAppointment) {
      getDataChartAppointment(yearChartAppointment.format('YYYY'), campaignChartAppointment);
    }
  }, [yearChartAppointment, campaignChartAppointment]);

  return (
    <div className="p-3">
      <Tabs
        type="line"
        size={'small'}
        className="[&_.ant-tabs-ink-bar]:!bg-primary"
        items={[
          {
            // doanh số chiến dịch
            label: t('campaign.chart-revenue'),
            key: '3',
            children: (
              <div>
                <h3 className="font-semibold w-full text-center">{t('campaign.revenue-title')}</h3>
                {/* <div className="w-full flex justify-end">
                <CustomSelect className="w-36" />
              </div> */}
                <Form form={formRevenue}>
                  <div className="flex justify-between">
                    <Form.Item name={'Year'} initialValue={dayjs(new Date())}>
                      <DatePicker picker="year" allowClear={false} />
                    </Form.Item>
                    <Form.Item name={'CampaignCode'}>
                      <CustomSelect
                        options={listCampaign}
                        fieldNames={{ label: 'campaignName', value: 'campaignCode' }}
                        filterOption={false}
                        popupMatchSelectWidth={false}
                        onSearch={(value) => debounceCampaign(value)}
                        placeholder={'Chọn chiến dịch'}
                        className="min-w-[136px] sm:!w-80"
                        allowClear
                        showSearch
                      />
                    </Form.Item>
                  </div>
                </Form>
                <ChartSalesCampaign
                  label={dataChartRevenue.label}
                  color={['#016F81']}
                  data={[
                    {
                      name: 'Doanh số (VNĐ)',
                      total: dataChartRevenue.data,
                    },
                  ]}
                />
              </div>
            ),
          },
          {
            // Số lượng khách ghé thăm
            label: t('campaign.chart-appointment'),
            key: '4',
            children: (
              <div>
                <h3 className="font-semibold w-full text-center">{t('campaign.appointment-title')}</h3>
                <Form form={formAppointment}>
                  <div className="flex justify-between">
                    <Form.Item name={'Year'} initialValue={dayjs()}>
                      <DatePicker picker="year" allowClear={false} />
                    </Form.Item>
                    <Form.Item name={'CampaignCode'}>
                      <CustomSelect
                        options={listCampaign}
                        fieldNames={{ label: 'campaignName', value: 'campaignCode' }}
                        filterOption={false}
                        popupMatchSelectWidth={false}
                        onSearch={(value) => debounceCampaign(value)}
                        placeholder={'Chọn chiến dịch'}
                        className="min-w-[136px] sm:!w-80"
                        allowClear
                        showSearch
                      />
                    </Form.Item>
                  </div>
                </Form>
                <ChartSalesCampaign
                  label={dataChartAppointment.label}
                  data={[
                    {
                      name: 'Số khách hàng ghé thăm',
                      total: dataChartAppointment.data,
                    },
                  ]}
                />
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}

export default ChartTab;
